import { render, staticRenderFns } from "./selectArea2.vue?vue&type=template&id=744fc9c4&scoped=true"
import script from "./selectArea2.vue?vue&type=script&lang=js"
export * from "./selectArea2.vue?vue&type=script&lang=js"
import style0 from "./selectArea2.vue?vue&type=style&index=0&id=744fc9c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744fc9c4",
  null
  
)

export default component.exports